import type { UserRepository } from '../repository/UserRepository';
import type { PatchUserRequest, PatchUserResponse } from '../entity/UserTypes';

export class PatchUserUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(request: PatchUserRequest): Promise<PatchUserResponse> {
    if (!request.user_id?.trim()) {
      throw new Error('user_id is required');
    }
    return this.repository.patchUser(request);
  }
}

